/* eslint-disable no-shadow */

export enum SubscriptionType {
  FREE = 'free',
  PREMIUM = 'premium',
  ATTRACTIVITY = 'attractivity',
}

export enum SubscriptionRank {
  NOT_CLIENT = 0,
  FREE = 1,
  ATTRACTIVITY = 2,
  PREMIUM = 3,
}

export interface Subscription {
  name: SubscriptionType
}
